import { render, staticRenderFns } from "./list-factory.vue?vue&type=template&id=6257d3f7&scoped=true&"
import script from "./list-factory.vue?vue&type=script&lang=js&"
export * from "./list-factory.vue?vue&type=script&lang=js&"
import style0 from "./list-factory.vue?vue&type=style&index=0&id=6257d3f7&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6257d3f7",
  null
  
)

export default component.exports